<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="1300">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <h1>Upload XML Nfe</h1>
              <v-icon size="34" color="#0F416E" style="width: 24px">mdi-tally-mark-1</v-icon>
              <h1 style="font-size: 18px">{{ filesTable.length }} arquivos</h1>
            </div>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="d-flex align-left text-left">
            <v-btn elevation="2" class="my-5 d-flex align-left text-left" color="success" @click="showFilePicker">
              Anexar XML
            </v-btn>
            <v-tooltip right nudge-top="1">
              <template #activator="{ attrs, on }">
                <v-icon class="mx-2" v-bind="attrs" v-on="on" size="20"> mdi-information-outline </v-icon>
              </template>
              <span
                >Os arquivos xml anexados precisam seguir o padrão original da emissão de NFes. <br />
                EX: 23240606850713000120550010030053921019442494-nfe-proc.xml</span
              >
            </v-tooltip>
          </div>
          <v-file-input
            ref="fileInput"
            multiple
            accept=".xml, text/xml"
            v-model="files"
            @change="addFiles"
            class="d-none"
          >
          </v-file-input>
          <v-data-table
            class="fixed-header"
            :headers="fileHeaders"
            :items="filesTable"
            :items-per-page="filesTable.length"
            :height="tableHeight"
            no-data-text="Sem arquivos selecionados"
            hide-default-footer
            fixed-header
          >
            <template v-slot:[`item.actions`]="{ index }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" @click="remove(index)" icon color="red" dark>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1 mr-2" large @click="close()">Cancelar</v-btn>
          <v-tooltip bottom :disabled="!isButtonDisabled">
            <template v-slot:activator="{ on, attrs }">
              <div class="flex-grow-1" v-bind="attrs" v-on="on">
                <v-btn
                  class="w-100"
                  color="success"
                  large
                  :disabled="isButtonDisabled"
                  @click="isOpenValidation = true"
                >
                  Confirmar
                </v-btn>
              </div>
            </template>
            <span v-if="!files.length">Selecione a(s) Nf-es para importação</span>
            <!-- <span v-else>Limite Máximo até 10 Arquivos por Importação</span> -->
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <import-confirm-dialog
      :isOpen.sync="isOpenValidation"
      @confirmClick="uploadXml()"
      :is-confirm-btn-loading="isUploadLoading"
      title="Confirmar Importação"
      body-text="Você confirma a importação desses arquivos XML?"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ImportConfirmDialog from '@/components/ConfirmDialog.vue';
import Base64Mixin from '@/mixins/base64.mixin';
import MessagesError from '@/components/MessagesError.vue';

export default {
  name: 'NfeXmlImportCreation',
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    manualBoardingId: {
      type: String,
      default: null
    }
  },
  components: {
    ImportConfirmDialog,
    MessagesError
  },
  mixins: [Base64Mixin],
  data() {
    return {
      isUploadLoading: false,
      files: [],
      filesBackup: [],
      documentImportXml: [],
      isOpenValidation: false,
      errors: [],
      errorsType: 'error',
      error500: null,
      fileHeaders: [
        {
          value: 'fileName',
          text: 'NOME DO ARQUIVO',
          sortable: true
        },
        {
          value: 'accessKeyNfe',
          text: 'CHAVE  NFE',
          sortable: true
        },
        {
          value: 'numberCte',
          text: 'NÚMERO NFE',
          sortable: true
        },
        {
          value: 'actions',
          align: 'end',
          text: '',
          sortable: false
        }
      ]
    };
  },

  computed: {
    parameterID() {
      return this.$route.params.id;
    },
    getFilenames() {
      const filenames = this.files.map((file) => file.name.split('_')[0]);
      return filenames;
    },

    filesTable() {
      const files = this.files.map((file) => {
        const accessKeyNfe = file.name.split('-')[0];
        return {
          fileName: file.name,
          accessKeyNfe: accessKeyNfe,
          numberCte: accessKeyNfe.substring(25, 34)
        };
      });
      return files;
    },

    tableHeight() {
      const hasMoreThanTen = this.files.length > 10;
      return hasMoreThanTen ? '450' : '';
    },

    isButtonDisabled() {
      if (!this.files.length) {
        return true;
      } else {
        return false;
      }
    }
  },

  methods: {
    ...mapActions('ImportManualNfeStore', ['uploadXmlNfe']),

    addFiles(newFiles) {
      if (newFiles.length) {
        this.filesBackup = [...new Set([...this.filesBackup, ...newFiles])];

        this.files = [...this.filesBackup];

        const uniqueFiles = Array.from(new Set(this.files.map((f) => f.name))).map((name) => {
          return this.files.find((f) => f.name === name);
        });

        this.files = [...uniqueFiles];
      }
    },

    showFilePicker() {
      const input = this.$refs.fileInput.$el.querySelector('input[type="file"]');
      input.click();
    },

    remove(index) {
      this.files.splice(index, 1);
      this.filesBackup = [...this.files];
    },

    async uploadXml() {
      try {
        this.isUploadLoading = true;

        for (const file of this.files) {
          const dataFiles = await this.toBase64(file);
          const documentsXml = {
            fileName: file.name,
            dataFiles: dataFiles.split('base64,')[1]
          };

          this.documentImportXml.push(documentsXml);
        }

        const documents = {
          manualBoardingImportId: this.parameterID,
          nfeXmlsViewModel: this.documentImportXml
        };

        const data = await this.uploadXmlNfe(documents);

        if (data.success) {
          this.errors = ['Upload realizado com sucesso! Os arquivos estão em processamento'];
          this.errorsType = 'success';
          await this.delay(300);
          this.$emit('shouldUpdateList');
        } else {
          this.errors = data.errors || ['Erro ao importar arquivos XML!'];
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.close();
        this.documentImportXml = [];
        this.isUploadLoading = false;
      }
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    clearFiles() {
      this.files = [];
      this.filesBackup = [];
    },

    close() {
      this.clearFiles();
      this.isOpenValidation = false;
      this.$emit('update:isOpen', false);
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .theme--light.v-data-table.v-data-table--fixed-header thead th {
  background-color: #e1e1e1;
}
</style>
